import React from 'react';
import { Toolbar, IconButton, Typography, Box, Container } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';

const TermsAndConditions = () => {
  return (
    <Box sx={{ flexGrow: 1, bgcolor: '#fff', minHeight: '100vh' }}>
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingX: '16px',
          mt: 4,
          mb: 2,
        }}
      >
        <IconButton
          edge="start"
          color="inherit"
          aria-label="back"
          onClick={() => history.back()}
        >
          <ArrowBackIcon sx={{ color: '#000' }} />
        </IconButton>
      </Toolbar>
      <Box sx={{ display: 'flex' }}>
        <InsertDriveFileOutlinedIcon
          sx={{ color: '#673AB7', fontSize: 40, ml: 2, textAlign: 'center' }}
        />
        <Typography
          variant="h6"
          sx={{ color: '#000', fontWeight: 600, fontSize: '18px', ml: 1 }}
        >
          Terms and conditions
        </Typography>
      </Box>

      <Container
        sx={{ padding: '20px 16px', textAlign: 'left', maxWidth: 'sm' }}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, fontSize: '16px', marginBottom: '12px' }}
        >
          1. Introduction
        </Typography>
        <Typography
          paragraph
          sx={{ fontSize: '14px', color: '#333', lineHeight: '1.6' }}
        >
          Welcome to EyeOp. By accessing or using our services, you agree to
          comply with and be bound by the following terms and conditions. Please
          read them carefully. If you do not agree with these terms, you should
          not use our platform.
        </Typography>

        <Typography
          variant="h6"
          sx={{ fontWeight: 600, fontSize: '16px', marginBottom: '12px' }}
        >
          2. User Accounts
        </Typography>
        <Typography
          paragraph
          sx={{ fontSize: '14px', color: '#333', lineHeight: '1.6' }}
        >
          To access certain features of our platform, you must create an
          account. You are responsible for maintaining the confidentiality of
          your account information, including your password, and for all
          activities that occur under your account.
        </Typography>

        <Typography
          variant="h6"
          sx={{ fontWeight: 600, fontSize: '16px', marginBottom: '12px' }}
        >
          3. Use of the Platform
        </Typography>
        <Typography
          paragraph
          sx={{ fontSize: '14px', color: '#333', lineHeight: '1.6' }}
        >
          You agree not to use the platform for unlawful purposes and in
          accordance with these terms:
        </Typography>
        <ul
          style={{
            paddingLeft: '16px',
            marginTop: '0',
            marginBottom: '20px',
            fontSize: '14px',
            color: '#333',
            lineHeight: '1.6',
          }}
        >
          <li>
            In any way that violates any applicable local, national, or
            international law or regulation.
          </li>
          <li>
            To send, knowingly receive, upload, download, use, or reuse any
            material that does not comply with our content standards.
          </li>
          <li>
            To transmit or procure the sending of any unsolicited or
            unauthorized advertising or promotional material or any other form
            of similar solicitation (spam).
          </li>
        </ul>

        <Typography
          variant="h6"
          sx={{ fontWeight: 600, fontSize: '16px', marginBottom: '12px' }}
        >
          4. Content Ownership and Use
        </Typography>
        <Typography
          paragraph
          sx={{ fontSize: '14px', color: '#333', lineHeight: '1.6' }}
        >
          All content provided on the platform, including text, graphics, logos,
          images, and software, is the property of EyeOp or its licensors.
        </Typography>
      </Container>
    </Box>
  );
};

export default TermsAndConditions;
